<template>
  <div class="loader">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<style scoped lang="scss">
.loader {
  --loader-size: 3dvh;
  --loader-border-width: 0.5dvh;

  width: var(--loader-size);
  height: var(--loader-size);

  div {
    position: absolute;
    width: var(--loader-size);
    height: var(--loader-size);
    border-width: var(--loader-border-width);
    border-style: solid;
    border-radius: 50%;
    border-color: var(--primary-color) transparent transparent transparent;
    animation: loader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;

    &:nth-child(1) {
      animation-delay: -0.45s;
    }
    &:nth-child(2) {
      animation-delay: -0.3s;
    }
    &:nth-child(3) {
      animation-delay: -0.15s;
    }
  }
}
@keyframes loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
